import React, { useRef, useState, useEffect } from "react";

import {
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useTracking } from "@local-logic/core/tracking";
import { useOnEventOutside } from "~/hooks/useOnEventOutside";
import { useRootElement } from "../context";

import * as styles from "./styles";

export function Content({ children }: { children?: React.ReactNode }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const tracking = useTracking();
  const { activeCategory, isExpanded, onToggleIsExpanded } = useRootElement();
  const [canClose, setCanClose] = useState(!isExpanded);

  useEffect(() => {
    // Need to wait for the next render to ensure the state is updated
    setCanClose(isExpanded);
  }, [isExpanded]);

  const handleClickOutside = () => {
    if (canClose) {
      tracking.postEvent({
        eventType: TrackingPipelineEvents.CATEGORIES_MENU_AUTO_CLOSED,
      });

      tracking.trackAnalyticsEvent({
        eventName: AnalyticsEvents.CATEGORIES_MENU_AUTO_CLOSED,
      });

      onToggleIsExpanded();
    }
  };

  useOnEventOutside(containerRef, "click", handleClickOutside);

  if (!isExpanded) {
    return null;
  }

  return (
    <div
      className={styles.container}
      ref={containerRef}
      data-testid="categories-panel"
      data-is-expanded={isExpanded}
      data-is-slider-open={!!activeCategory}
    >
      {children}
    </div>
  );
}
